// Approved by teacher listening comparison: the same recordings at 0.60×,
// with pitch preserved. Apply on every clip because tours reuse one Audio.
export const PRONUNCIATION_PLAYBACK_RATE = 0.6;

export function setPronunciationPlayback(audio, pronunciation = true) {
  audio.playbackRate = pronunciation ? PRONUNCIATION_PLAYBACK_RATE : 1;
  audio.preservesPitch = true;
  if ('webkitPreservesPitch' in audio) audio.webkitPreservesPitch = true;
}

export function setRoundAudioPlayback(audio, round, id) {
  // Use the authored target references, including legacy IDs and basket examples.
  // Instructions, help, feedback and effects are not pronunciation targets.
  const targets = [...(round.items || []), ...(round.choices || []),
    ...(round.basket_references || []), round.reference];
  setPronunciationPlayback(audio, !!id && targets.some(target => target?.audio_id === id));
}
